import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MediaStatsFormatted } from '@app/shared/models/media-stats';
import { PricingModelEnum } from '@app/shared/models/enums/pricingModel.enum';

@Component({
  selector: 'flow-media-stats',
  templateUrl: './media-stats.component.html',
  styleUrls: ['./media-stats.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MediaStatsComponent {
  @Input() media: MediaStatsFormatted = null;
  @Input() toggleExtendedInfo = false

  PricingModelEnum = PricingModelEnum;
}
